import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';

export const Wrapper = styled.div`
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding: 0 30px;

    ${({ long }) => long && css`
        max-width: 100%;
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        padding: 0 15px;
    }
`;
